import utilsApi from './utils';
import contactApi from './contact';


export default {
  ...utilsApi,
  ...contactApi,
}



// WEBPACK FOOTER //
// ./src/api/index.js